import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Trash2, Plus, Instagram } from "lucide-react";
import { toast } from "sonner";

export const InstagramManager = () => {
  const [posts, setPosts] = useState([]);
  const [form, setForm] = useState({ image_url: "", caption: "", post_url: "" });

  const load = () => api.get("/instagram/posts").then((r) => setPosts(r.data)).catch(() => {});

  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.image_url) { toast.error("URL da imagem é obrigatória"); return; }
    try {
      await api.post("/instagram/posts", form);
      toast.success("Post adicionado");
      setForm({ image_url: "", caption: "", post_url: "" });
      load();
    } catch { toast.error("Erro ao adicionar"); }
  };

  const del = async (id) => {
    if (!window.confirm("Remover post?")) return;
    try { await api.delete(`/instagram/posts/${id}`); toast.success("Removido"); load(); }
    catch { toast.error("Erro"); }
  };

  return (
    <div className="space-y-5">
      <Card className="bg-slate-900/50 border-slate-800">
        <CardContent className="p-6">
          <div className="flex items-center gap-2 text-pink-400 mb-1">
            <Instagram className="w-5 h-5" />
            <h2 className="text-lg font-bold text-white">Novo post do feed</h2>
          </div>
          <p className="text-xs text-slate-400 mb-4">Adicione a URL de uma imagem do seu Instagram e o link do post. O cliente vê como grade na landing.</p>
          <div className="grid gap-3">
            <div>
              <Label className="text-slate-300 text-xs">URL da imagem</Label>
              <Input value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} placeholder="https://..." className="bg-slate-800 border-slate-700 text-white mt-1 h-10" data-testid="insta-image-input" />
            </div>
            <div>
              <Label className="text-slate-300 text-xs">Legenda (opcional)</Label>
              <Textarea value={form.caption} onChange={(e) => setForm({ ...form, caption: e.target.value })} rows={2} placeholder="Civic 2020 - recarga de gás concluída" className="bg-slate-800 border-slate-700 text-white mt-1" />
            </div>
            <div>
              <Label className="text-slate-300 text-xs">Link do post no Instagram (opcional)</Label>
              <Input value={form.post_url} onChange={(e) => setForm({ ...form, post_url: e.target.value })} placeholder="https://instagram.com/p/..." className="bg-slate-800 border-slate-700 text-white mt-1 h-10" />
            </div>
            <Button onClick={add} className="bg-gradient-to-r from-[#833AB4] via-[#E1306C] to-[#F77737] text-white font-bold hover:brightness-110 h-10" data-testid="insta-add-btn">
              <Plus className="w-4 h-4 mr-1" /> Adicionar ao feed
            </Button>
          </div>
        </CardContent>
      </Card>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {posts.length === 0 && <div className="text-slate-400 text-center py-6 col-span-full">Nenhum post ainda.</div>}
        {posts.map((p) => (
          <Card key={p.post_id} className="bg-slate-900/50 border-slate-800 overflow-hidden">
            <img src={p.image_url} alt={p.caption} className="w-full aspect-square object-cover" />
            <CardContent className="p-3 flex items-center justify-between gap-2">
              <div className="text-xs text-slate-300 truncate flex-1">{p.caption || "—"}</div>
              <Button size="icon" variant="ghost" onClick={() => del(p.post_id)} className="text-red-400 hover:bg-red-500/10 h-8 w-8 shrink-0">
                <Trash2 className="w-4 h-4" />
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
